import Box from '@mui/material/Box';
import type { BoxProps } from '@mui/material/Box';

/**
 * The company mark in the app bar — from `md` up, and nowhere below it.
 *
 * A phone's bar is a title between two rows of buttons, and the mark is the one
 * thing on it that says nothing about where the user is or what they can do: it
 * goes first, so the Maßnahmenname keeps the width.
 *
 * One component rather than an `<img>` per chrome: the office and the field
 * bars are different components, and the breakpoint at which the mark appears
 * should not drift apart between them.
 *
 * `alt=""` on purpose — decoration beside a title that already names the app,
 * and a screen reader announcing "AST logo" before every heading is noise.
 */
export default function AppBarLogo({ sx }: { sx?: BoxProps['sx'] }) {
    return (
        <Box
            component="img"
            src="/ast-logo-mono-white.svg"
            alt=""
            sx={[
                {
                    display: { xs: 'none', md: 'block' },
                    height: 34,
                    flexShrink: 0
                },
                ...(Array.isArray(sx) ? sx : [sx])
            ]}
        />
    );
}
